import React, { useState } from 'react';
import BackHeader from './BackHeader';
import { STATIC } from '../staticMode';
import { useVersions } from '../hooks/useVersions';

const SIZES = [
  { label: '小', v: 0.85 },
  { label: '中', v: 1.0 },
  { label: '大', v: 1.2 },
  { label: '特大', v: 1.45 },
];

// Ports the phone's SettingsScreen: font size + update check + version.
export default function SettingsScreen({ onBack, fontScale, setFontScale, version, user, logout }) {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('');
  const { sel, toggle } = useVersions();

  const checkUpdate = () => {
    setBusy(true); setStatus('更新完成，重新啟動…');
    setTimeout(() => window.location.reload(), 600);   // a reload always fetches the newest bundle
  };

  const fs = fontScale || 1;

  return (
    <div className="settings">
      <BackHeader title="設定" onBack={onBack} />
      <div className="set-scroll">
        <h3 className="set-h">字體大小</h3>
        <div className="set-size-row">
          {SIZES.map((sz) => (
            <button key={sz.label} className={`set-size-btn${Math.abs(fs - sz.v) < 0.01 ? ' on' : ''}`}
              onClick={() => setFontScale(sz.v)}>{sz.label}</button>
          ))}
        </div>
        <p className="set-sample" style={{ fontSize: Math.round(22 * fs), lineHeight: `${Math.round(34 * fs)}px` }}>
          Berah mmteru knkawas
        </p>

        <h3 className="set-h">對照譯本</h3>
        <p className="set-p">
          族語經文底下要並列什麼。譯本由族語版本決定：德固達雅語譯自 KJV 與和合本，
          太魯閣語則對照現中2019與 GNB。
        </p>
        <div className="set-ver-row">
          <button className={`set-ver-btn${sel.zh ? ' on' : ''}`} onClick={() => toggle('zh')}>
            <span className="set-ver-label">中文</span>
            <span className="set-ver-note">和合本2010／現中2019</span>
          </button>
          <button className={`set-ver-btn${sel.en ? ' on' : ''}`} onClick={() => toggle('en')}>
            <span className="set-ver-label">English</span>
            <span className="set-ver-note">KJV／GNB</span>
          </button>
        </div>
        <p className="set-hint">兩者可同時顯示，也可都不顯示。</p>

        <h3 className="set-h">應用程式更新</h3>
        <p className="set-p">下載最新的內容與修正，不需重新安裝。</p>
        <button className="set-btn" onClick={checkUpdate} disabled={busy}>檢查更新</button>
        {status ? <p className="set-status">{status}</p> : null}
        <p className="set-meta">版本 {version}</p>

        {!STATIC && user && (
          <>
            <h3 className="set-h">帳號</h3>
            <p className="set-p">{user.name}</p>
            <button className="set-btn" onClick={logout}>登出</button>
          </>
        )}
      </div>
    </div>
  );
}
